import React from 'react'

import Netflix_Banner from '../assets/images/netflix-clone-2.png'
import fakeflix_responsive from "../assets/images/fakeflix-responsive-2.png"
import netflix_video from "../assets/videos/fakeflix-video.mp4"
import next_prev from "../assets/images/log-out.png"

import { motion } from 'framer-motion'
import ReactPlayer from 'react-player'
import "./Project.scss"
import { useNavigate } from "react-router-dom";


const content = (isFirstMount) => ({
    animate: {
        transition: { staggerChildren: 0.1, delayChildren: isFirstMount ? 2.8 : 0 },
    },
});

const title = {
    initial: { y: -20, opacity: 0 },
    animate: {
        y: 0,
        opacity: 1,
        transition: {
            duration: 0.7,
            ease: [0.6, -0.05, 0.01, 0.99],
        },
    },
};

export default function Fakeflix({ isFirstMount }) {

    let navigate = useNavigate();
    function handleClick() {
        navigate("/");
    }

    return (
        <motion.div exit={{ opacity: 0 }} className="individual_ones">
            {isFirstMount && <InitialTransition />}
            <motion.div
                initial="initial"
                animate="animate"
                variants={content(isFirstMount)}
                className="first6"
            >
                <section className="project_banner">
                    <div className="header">
                        <span className="" onClick={handleClick}>
                            Back To Main
                        </span>
                    </div>
                    <motion.div className="project_name"
                        variants={title}>
                        Fakeflix
                    </motion.div>
                    <motion.div className="banner_image"
                        variants={title}>
                        <img src={Netflix_Banner}
                            alt="Fakeflix Banner"
                            loading='lazy'
                        />
                    </motion.div>
                </section>
                <section className="project_description">
                    <div className="row">
                        <div className="column"></div>
                        <div className="column title">
                            A different type of Netflix clone, with
                            sleek animations and unique design
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="para_heading">
                                Timeline
                            </div>
                            <div className="para_details">
                                November 2021 - December 2021
                            </div>
                        </div>
                        <div className="column">
                            <div className="para_heading">
                                Description
                            </div>
                            <div className="para_details">
                                <p>
                                    Fakeflix is a Netflix clone website created with the purpose
                                    of learning more about structuring the animations in a website
                                    of mid-level complexity, along with experiencing a fresh yet
                                    modern look & feel.
                                </p>
                                <p>
                                    The website allows users to sign-up or sign-in using either email,
                                    google or anonimously. The layout is replicated as close as possible
                                    to the original website, featuring both the "Splash" animation and the
                                    "ta-dumm" sound.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="para_heading">
                                Link
                            </div>
                            <div className="para_details">
                                <a href="https://netflix-clone-v2.vercel.app/" 
                                target='_blank' rel='noreferrer'>
                                    netflix-clone-v2.vercel.app
                                </a>
                            </div>
                        </div>
                        <div className="column">
                            <div className="para_heading">
                                Solution
                            </div>
                            <div className="para_details">
                                <p>
                                    The project is created in React.js and for this, I used Redux and
                                    Firebase authentication to add the sign-up and sign-in feature. I
                                    used TMDB's API to showcase the list of movies and TV series. The
                                    project is fully responsive and for the animations, I used Swiper.js
                                    and Framer Motion.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="demo_video">
                        <ReactPlayer
                            className='react-player fixed-bottom'
                            url={netflix_video}
                            width='100%'
                            height='100%'
                            loop={true}
                            muted={true}
                            controls={false}
                            playing={true}
                        />
                    </div>
                    <div className="row">
                        <div className="column"></div>
                        <div className="column title">
                            TYPOGAPHY
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="para_heading">
                                Bebas Neue
                            </div>
                            <div className="para_details">
                                Fakeflix logo Typography
                            </div>
                        </div>
                        <div className="column">
                            <div className="para_details only"
                                style={{ fontFamily: "Bebas Neue, cursive" }}
                            >
                                <p>Aa Bb Cc Dd Ee Ff Gg Hh Ii</p>
                                <p>Jj Kk Ll Mm Nn Oo Pp Qq Rr</p>
                                <p>Ss Tt Uu Vv Ww Xx Yy Zz</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="para_heading">
                                Inter
                            </div>
                            <div className="para_details">
                                Website Typography
                            </div>
                        </div>
                        <div className="column">
                            <div className="para_details only"
                                style={{ fontFamily: "Inter, sans-serif" }}
                            >
                                <p>Aa Bb Cc Dd Ee Ff Gg Hh Ii</p>
                                <p>Jj Kk Ll Mm Nn Oo Pp Qq Rr</p>
                                <p>Ss Tt Uu Vv Ww Xx Yy Zz</p>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ marginTop: "4vw" }}>
                        <div className="column title">
                            Color Swatches
                        </div>
                        <div className="column">
                            <div className="swatch_container">
                                <div className="swatch">
                                    <div className="bg_color"></div>
                                    <h3 className="color_code">#f2f2f2</h3>
                                </div>
                                <div className="swatch">
                                    <div className="bg_color"
                                        style={{ border: "1px solid whitesmoke" }}
                                    ></div>
                                    <h3 className="color_code" >
                                        #141414
                                    </h3>
                                </div>
                                <div className="swatch">
                                    <div className="bg_color"></div>
                                    <h3 className="color_code">#e50914</h3>
                                </div>
                                <div className="swatch">
                                    <div className="bg_color"></div>
                                    <h3 className="color_code">#1356c7</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="project_footer">
                    <div className="responsive_image">
                        <img src={fakeflix_responsive} alt=""
                            style={{ width: "100%", height: "100%" }}
                            loading='lazy'
                        />
                    </div>
                    <div className="other_projects">
                        <a href="/googlestories" className="prev_project">
                            <img src={next_prev} alt="previous project"
                                className="rotate"
                                loading='lazy'
                            />
                            <span>Previous Project</span>
                        </a>
                        <a href="/meadlight" className="next_project">
                            <span>Next Project</span>
                            <img src={next_prev} alt="next project"
                                loading='lazy'
                            />
                        </a>
                    </div>
                </section>
            </motion.div>
        </motion.div>
    )
}





const blackBox = {
    initial: {
        height: "100vh",
        bottom: 0,
    },
    animate: {
        height: 0,
        transition: {
            when: "afterChildren",
            duration: 1.5,
            ease: [0.87, 0, 0.13, 1],
        },
    },
};

const textContainer = {
    initial: {
        opacity: 1,
        width: "100%"
    },
    animate: {
        opacity: 0,
        transition: {
            duration: 0.3,
            when: "afterChildren",
        },
    },
};

const text = {
    initial: {
        y: 40,
    },
    animate: {
        y: 80,
        transition: {
            duration: 1.5,
            ease: [0.87, 0, 0.13, 1],
        },
    },
};


const InitialTransition = () => {

    return (
        <motion.div
            className="first1"
            initial="initial"
            animate="animate"
            variants={blackBox}
            onAnimationStart={() => {
                document.body.classList.add("overflow-hidden")
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            onAnimationComplete={() => {
                document.body.classList.remove("overflow-hidden")
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
        >
            <motion.svg variants={textContainer} className="first2">
                <pattern
                    id="pattern"
                    patternUnits="userSpaceOnUse"
                    width={750}
                    height={800}
                    className="text-white"
                >
                    <rect className="first3" />
                    <motion.rect
                        variants={text}
                        className="first4"
                    />
                </pattern>
                <text
                    className="first5"
                    textAnchor="middle"
                    x="50%"
                    y="50%"
                    style={{ fill: "url(#pattern)" }}
                >
                    fakeflix
                </text>
            </motion.svg>
        </motion.div>
    );
};